import { render } from "./SectionTravelForm.vue?vue&type=template&id=1194467b&scoped=true"
import script from "./SectionTravelForm.vue?vue&type=script&lang=js"
export * from "./SectionTravelForm.vue?vue&type=script&lang=js"

import "./SectionTravelForm.vue?vue&type=style&index=0&id=1194467b&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1194467b"]])

export default __exports__